import RequestHandler from "./request-handler";
class MeterReplaceListService {
    constructor() {
        this.path = "MeterReplace";
        if (MeterReplaceListService.instance) {
            return MeterReplaceListService.instance;
        }
        MeterReplaceListService.instance = this;
        return this;
    }
    async get() {
        return await RequestHandler.get(this.path);
    }
    async getByCustomerIdAndDate(id, date) {
        return await RequestHandler.getWithParams(this.path + '/getByCustomerIdAndDate', {
            customerId: id,
            date: date
        });
    }
    async insert(data) {
        return await RequestHandler.post(this.path, data);
    }
    async update(data) {
        return RequestHandler.put(this.path, data);
    }
    async delete(id) {
        return await RequestHandler.delete(this.path, id);
    }
}
const instance = new MeterReplaceListService();
export default instance;